import {createStore,applyMiddleware} from 'redux';
import{composeWithDevTools} from 'redux-devtools-extension'
import sagaMiddleware1 from 'redux-saga';
import {commonReducer} from './Reducer/commonReducer';
import rootSaga from './Saga/index';
const sagaMiddleware = sagaMiddleware1();

export const store = createStore(commonReducer,composeWithDevTools(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(rootSaga);